import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AppShell } from 'design-system'
import { ShiftProvider } from 'hooks/useShift'
import { useAuth } from 'slices/user/hooks'
import { useBranch } from 'hooks/useBranch'
import OfflineBanner from 'Components/Common/OfflineBanner'
import { tenantAPI } from 'api/tenant'
import { resolveMediaUrl } from 'Components/Form/ImageUploadField'
import { publicAssetPath } from 'helpers/publicAssetPath'
import { setAppTimezone } from 'helpers/dateTime'
import { TenantAccessGuard } from 'Components/Security/TenantAccessGuard'
import { usePlanAccess } from 'hooks/usePlanAccess'
import { buildSidebarMenu } from './buildSidebarMenu'

const NewLayout = (props: any) => {
 const { t, i18n } = useTranslation()
 const { hasPermission, isSuperAdmin } = useAuth()
 const { hasFeature } = usePlanAccess()
 const { viewMode } = useBranch()
 const filtered = useMemo(
 () => buildSidebarMenu(isSuperAdmin, hasPermission, viewMode, hasFeature, t),
 // i18n.language: t identity is stable across locale changes
 // eslint-disable-next-line react-hooks/exhaustive-deps -- recompute on language change
 [isSuperAdmin, hasPermission, viewMode, hasFeature, t, i18n.language],
 )
 const [brandLogo, setBrandLogo] = useState<string | undefined>(undefined)
 const [brandName, setBrandName] = useState<string | undefined>(undefined)

 useEffect(() => {
 let cancelled = false
 tenantAPI
 .info()
 .then((res) => {
 if (cancelled) return
 if (res.status !== 'success') return
 const t = res.data?.tenant
 const companyName = String(t?.contact_info?.company_name || '').trim()
 const logoUrl = String(t?.contact_info?.logo_url || '').trim()
 const fallbackName = String(t?.name || '').trim()

 if (t?.timezone) setAppTimezone(t.timezone)

 if (companyName) setBrandName(companyName)
 else if (fallbackName) setBrandName(fallbackName)

 if (logoUrl) setBrandLogo(resolveMediaUrl(logoUrl) || logoUrl)
 })
 .catch(() => {})

 return () => {
 cancelled = true
 }
 }, [])

 return (
 <AppShell menuItems={filtered} logo={brandLogo ?? publicAssetPath('logo.png')} appName={brandName}>
 <TenantAccessGuard>
 <OfflineBanner />
 <ShiftProvider>{props.children}</ShiftProvider>
 </TenantAccessGuard>
 </AppShell>
 )
}

export default NewLayout
